import { Injectable } from '@angular/core';
import { isSuffixSegment } from '@common/helpers';
import { PostJourneysGetJourneyResponseDataFlightsInner } from 'src/sdk_checkin';

@Injectable({
  providedIn: 'root',
})
export class CheckinSeatmapDisplaySegmentService {
  constructor() {}

  /**
   * 与えられたセグメントが、座席指定対象セグメントかを以下の条件にて判定する
   * ・当該セグメントがSuffix便でない
   * ・NHグループ運航便の国際線、またはNHグループ販売便名またはNHグループ運航便名の国内線である
   * NOTE：これはどの画面からの遷移であっても共通的に実施される判定であり、遷移元によってはこの条件に加えて追加の条件で判定する部分もある
   * @param segment 判定対象のセグメント
   * @returns 条件を全て満たす場合、表示対象セグメントであるとしてtrueを返却し、それ以外の場合は表示対象ではないとしてfalseを返却する
   */
  isDisplayTargetSegment(segment: PostJourneysGetJourneyResponseDataFlightsInner) {
    // NHグループ運行便の国際線かどうか
    const isDisplayTargetSegumentForInternational =
      segment.routeType === PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum.Int &&
      segment.operatingType === PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum.NhGroupOperating;

    // NHグループ運行便、またはNHグループ販売便の国内線かどうか
    const isDisplayTargetSegumentForDomestic =
      segment.routeType === PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum.Dom &&
      (segment.operatingType === PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum.NhGroupOperating ||
        segment.operatingType === PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum.NhGroupMarketing);

    return (
      !isSuffixSegment(segment.marketingFlightNumber || '') &&
      (isDisplayTargetSegumentForInternational || isDisplayTargetSegumentForDomestic)
    );
  }
}
